import React, { useState, useRef } from "react";
import { useSpring, animated } from "react-spring";
import styled from "styled-components";
import { MdOutlineArrowBack } from "react-icons/md";
import userVal from "vars/user";
import VerifyEmail from "components/Settings/ChangePhoneNumber/VerifyEmail";
import VerifyCurrentNumber from "components/Settings/ChangePhoneNumber/VerifyCurrentNumber";
import VerifyOtp from "components/Settings/ChangePhoneNumber/VerifyOtp";
import VerifyNewNumber from "components/Settings/ChangePhoneNumber/VerifyNewNumber";
import ConfirmPin from "components/Settings/ChangePhoneNumber/ConfirmPin";
import { Portal } from "@chakra-ui/react";

const Background = styled.div`
  position: fixed;
  max-width: 500px;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  /* z-index: 10000000000000; */
  margin: auto;
`;

const ModalContents = styled.div`
  height: 500px;
  border-radius: 24px 24px 0px 0px;

  button {
    border-radius: 24px;
  }

  .line {
    height: 5px;
    width: 30px;
    background: #b3b6ba;
  }

  .title {
    color: #4285f4;
    font-weight: 500;
    font-size: 1rem;
    margin-right: 1.8rem;
  }
`;

const DropDownPage = styled.div`
  .dropdown {
    width: 100%;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    position: relative;
    user-select: none;
  }

  .dropdown .dropdown-btn {
    /* background: #F7FAFF; */
    padding: 0.875rem 1.06rem;
    font-size: 1rem;
    cursor: pointer;
    color: #b3b6ba;
  }

  .dropdown .dropdown-content {
    /* padding: 15px; */
    background: #f7faff;
    font-size: 0.875rem;
    box-sizing: border-box;
    margin-top: 0.3rem;
  }

  .dropdown .dropdown-content .dropdown-item {
    padding: 1rem;
    cursor: pointer;
  }
`;

const ModalWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const InputField = styled.div``;

const Modal = ({ changePhone, setChangePhone }) => {
  const [steps, setStep] = useState(1); 
  const [currentPhone] = useState(userVal()?.phoneNumber);
  const [email, setemail] = useState("");
  const [otp, setotp] = useState("");
  const [country, setCountry] = useState("");
  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [confirmPhoneNumber, setConfirmPhoneNumber] = useState("");
  const [pin, setpin] = useState("");

  const handleSteps = () => {
    if (steps > 0 && steps < 5) {
      setStep((prev) => prev + 1);
    }
  };
  const handleBack = () => {
    if (steps > 1 && steps <= 5) {
      setStep((prev) => prev - 1);
    } else {
      setChangePhone(false);
    }
  };

  const setModal = useRef();

  const closeModal = (e) => {
    if (setModal.current === e.target) {
      setChangePhone(false);
    }
  };

  const animate = useSpring({
    config: {
      duration: 250,
    },
    opacity: changePhone ? 1 : 0,
    transform: changePhone ? `translateY(0%)` : `translateY(100%)`,
  });

  return (
    <>
      {changePhone && (
        <Portal>
          <Background ref={setModal} onClick={closeModal}>
            <ModalWrapper changePhone={changePhone}>
              <animated.div style={animate}>
                <ModalContents className="p-4 bg-white dark:bg-[#343B46]">
                  <div className="flex mt-2 justify-center mb-2.5">
                    <div className="line"></div>
                  </div>

                  <div className="flex items-center justify-between px-2 mb-4">
                    <div className="items-center" onClick={handleBack}>
                      <MdOutlineArrowBack size={36} color="#4285F4" />
                    </div>
                    <div className="title mr-4">Change phone number</div>
                    <div></div>
                  </div>

                  <InputField>
                    {(steps === 1 || steps > 5) && (
                      <VerifyCurrentNumber
                        handleSteps={handleSteps}
                        currentPhone={currentPhone}
                      />
                    )}

                    {steps === 2 && (
                      <VerifyEmail
                        email={email}
                        setemail={setemail}
                        currentPhone={currentPhone}
                        handleSteps={handleSteps}
                      />
                    )}

                    {steps === 3 && (
                      <VerifyOtp
                        otp={otp}
                        setotp={setotp}
                        currentPhone={currentPhone}
                        handleSteps={handleSteps}
                        email={email}
                      />
                    )}

                    {steps === 4 && (
                      <VerifyNewNumber
                        country={country}
                        setCountry={setCountry}
                        newPhoneNumber={newPhoneNumber}
                        setNewPhoneNumber={setNewPhoneNumber}
                        confirmPhoneNumber={confirmPhoneNumber}
                        setConfirmPhoneNumber={setConfirmPhoneNumber}
                        handleSteps={handleSteps}
                      />
                    )}

                    {steps === 5 && (
                      <ConfirmPin
                        currentPhone={currentPhone}
                        newPhoneNumber={newPhoneNumber}
                        pin={pin}
                        setpin={setpin}
                        otp={otp}
                        userId={userVal()?.id}
                      />
                    )}
                  </InputField>
                </ModalContents>
              </animated.div>
            </ModalWrapper>
          </Background>
        </Portal>
      )}
    </>
  );
};

export default Modal;
